import { defineComponent, h, nextTick, withDirectives, resolveDirective } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import {
    QSelect, QBtn, QIcon, QMenu, QCard, QBar, QToolbarTitle, QCardSection, QCardActions,
    QInput, QList, QItem, QItemSection, QItemLabel, QSpace, QTooltip, QAvatar,
} from 'quasar';

import { appSettings } from '@/Shared/appSettings.js';

import TranslationContainer from '../TranslationContainer.jsx';
import VerticalStack from '../VerticalStack.jsx';

export default defineComponent({
    name: 'sform-ttsvoicepicker',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        VerticalStack,
        QSelect, QBtn, QIcon, QMenu, QCard, QBar, QToolbarTitle, QCardSection, QCardActions,
        QInput, QList, QItem, QItemSection, QItemLabel, QSpace, QTooltip, QAvatar,
    },
    data: () => ({
        localesection: null,
        localeexpn: null,
        //listitems: [],
        genders: [],
        //providers: [],
        types: [],

        genders_selection: ['All'],
        providers_selection: ['All'],
        types_selection: ['All'],
        sortoptions: [
            { title: 'No sort', value: 'none' },
            { title: 'Sort name ascending', value: 'na' },
            { title: 'Sort name descending', value: 'nd' },
            { title: 'Sort provider ascending', value: 'pa' },
            { title: 'Sort provider descending', value: 'pd' }
        ],
        sortselection: ['none'],
        sortMenuState: false,

        menuState: false,
        selectedvalue: [],
        nameplaying: null,

        search_text: '',

        sampleText: 'Text to speech synthesizes natural sounding speech with 100+ voices, available in multiple languages and variants.',
        sampleTextVisible: false,
        soundPlayer: null,
        statewatch: null,
    }),
    props: {
    },
    created() {
        this.genders = [
            { title: 'All' },
            { title: 'Male' },
            { title: 'Female' },
            { title: 'Neutral' },
        ];
        //this.providers = [
        //    { title: 'All' },
        //    { title: 'Deepgram' },
        //    { title: 'Elevenlabs' },
        //    { title: 'Google' },
        //    { title: 'IBM' },
        //    { title: 'Microsoft' },
        //];
        this.types = [
            { title: 'All' },
            { title: 'Standard' },
            { title: 'Neural' },
            { title: 'News' },
            { title: 'Studio' },
            { title: 'Wavenet' },
            { title: 'Journey' },
            { title: 'Polyglot' },
            { title: 'Casual' },
        ];
    },
    async mounted() {
        // If this field is inside a localesection, get the locale from there
        // and don't worry about loading the voices, the localesection does that.
        this.localesection = this.ParentByType('sform-localesection');
        if (!this.localesection) {

            await this.loadAllVoices();
            this.buildVoiceMap();
        }

        if (this.element.formatData.locale)
            this.localeexpn = utils.compile(this, this.element.formatData.locale);

        //this.listitems = utils.global.VoiceMap['en-us'];
        //this.providers = ['All', ...new Set(this.listitems.map(a => a.Vendor))];

        if (this.element.formatData.soundPlayer) {
            const expn = utils.compileExpression(this, this.element.formatData.soundPlayer);
            this.soundPlayer = utils.evaluate(expn, this);
            if (this.soundPlayer)
                this.statewatch = this.$watch(() => this.soundPlayer.State, (newv) => {
                    if (newv == 'Stopped')
                        this.nameplaying = null;
                });
        }

        this.loadComplete();
    },
    unmounted() {
        if (this.statewatch)
            this.statewatch();
    },
    computed: {
        locale() {
            //if (this.localesection)
            //    return this.localesection.locale;
            //else
            if (this.localeexpn)
                return utils.evaluate(this.localeexpn, this) || 'en-us';
            else
                return 'en-us';
        },
        listitems() {
            if (this.locale && utils.global.VoiceMap)
                return utils.global.VoiceMap[this.locale] ?? [];
            else
                return [];
        },
        providers() {
            if (this.listitems)
                return ['All', ...new Set(this.listitems.map(a => a.Vendor))];
            else
                return ['All'];
        },
        filteredlist() {
            let filtered = this.listitems;
            if (!this.genders_selection.some(i => i == 'All'))
                filtered = filtered.filter(a => {
                    return this.genders_selection.some(i => {
                        return a.Friendly.includes(`(${i})`);
                    });
                });

            if (!this.providers_selection.some(i => i == 'All'))
                filtered = filtered.filter(a => this.providers_selection.some(i => a.Vendor == i));

            if (!this.types_selection.some(i => i == 'All'))
                filtered = filtered.filter(a => this.types_selection.some(i => a.Name.includes(i)));

            if (this.search_text)
                filtered = filtered.filter(a => a.Friendly.toLowerCase().includes(this.search_text.toLowerCase()) || a.Region.toLowerCase().includes(this.search_text.toLowerCase()));

            if (this.sortselection.length && this.sortselection[0] != 'none')
                filtered = filtered.toSorted((a,b) => this.sortBy(a, b, this.sortselection[0]));

            return filtered;
        },
    },
    watch: {
        locale(newv) {
            console.log(`Watch detected change to locale: ${newv}`);
            if (newv && newv.includes('-')) {
                const key = `TTSVoicePicker-SampleVoice-${newv.split('-')[0]}`;
                const text = this.System.LocalStorage(key);
                if (text) {
                    this.sampleText = text;
                    console.log(`Restored TTS sample text from key:${key} as ${text}`);
                }
            }
        },
    },
    methods: {
        async loadAllVoices() {
            if (!utils.global.AllVoices)
                utils.global.AllVoices = await utils.api.get('Apps/Locale/GetAvailableTTSVoices', false, true);

            if (!utils.global.LocaleList)
                this.saveListItems(await utils.api.get('Apps/CMPhoneUtils/GetMappings', false, true));
        },
        buildVoiceMap() {
            if (utils.global.VoiceMap)
                return;

            let map = {};
            let regionMap = {};
            let allVoice = utils.global.AllVoices;

            for (let i = 0; i < allVoice.length; i++) {
                let voice = allVoice[i];
                let region = voice.Region.toLowerCase();
                let locale = voice.Locale.toLowerCase();
                if (!map[region]) {
                    map[region] = [];
                }
                if (!map[locale]) {
                    map[locale] = [];
                }
                if (!regionMap[region]) {
                    regionMap[region] = [];
                }
                map[region].push(voice);
                map[locale].push(voice);
                regionMap[region] = locale;
                regionMap[locale] = locale;
            }
            let allLocales = utils.global.LocaleList;

            for (let j = 0; j < allLocales.length; j++) {
                let loc = allLocales[j];
                if (loc.key.indexOf("-") >= 0) {
                    if (!map[loc.key]) {
                        let locPieces = loc.key.split("-");
                        let missingRegion = locPieces[0];
                        map[loc.key] = map[missingRegion]
                        regionMap[loc.key] = missingRegion;
                    }
                }
            }

            utils.global.VoiceMap = map;
            utils.global.RegionMap = regionMap;
        },
        saveListItems(countryInfoMappings) {
            let mappingsDict = {};
            countryInfoMappings.forEach(el => {
                if (el.countrycode) {
                    let key = el.countrycode.toLowerCase();
                    mappingsDict[key] = el;
                }
            })

            let availLangs = this.getAvailableLanguages();
            let listItems = [];


            availLangs.forEach(availLang => {
                // Put the language in the list 
                let langDisplay = '';

                if (availLang.native) {
                    langDisplay = availLang.native; // + ' (' + availLang.name + ')';
                }
                else {
                    langDisplay = availLang.name;
                }

                let langObj = {
                    "key": availLang.key,
                    "display": langDisplay,
                    "flagpath": null
                };

                listItems.push(langObj);

                availLang.locales.forEach(availLocale => {
                    let flagpath = null;

                    let parts = availLocale.key.split('-');
                    let lang = '';
                    let locale = '';

                    if (parts.length === 0) {
                        return; // Same as continue in typical for-loop
                    }
                    else if (parts.length === 1) {
                        lang = parts[0];
                        locale = parts[0];
                    }
                    else {
                        lang = parts[0];
                        locale = parts.splice(1).join("-");
                    }

                    if (locale in mappingsDict) {
                        flagpath = mappingsDict[locale].flagpath;
                    }

                    let localeObj = {
                        "key": availLocale.key,
                        "display": langDisplay + ' - ' + availLocale.name,
                        "flagpath": flagpath
                    };

                    listItems.push(localeObj);
                })
            });

            utils.global.LocaleList = listItems;

            return true;
        },
        getAvailableLanguages() {
            // debugger;
            var generalList = this.System.AvailableLanguages;
            if (this.System.WhiteLabel.LimitLanguages && JSON.parse(this.System.WhiteLabel.LimitLanguages)) {
                var whiteLabelList = JSON.parse(this.System.WhiteLabel.Languages);
                generalList = generalList.filter(l => whiteLabelList.includes(l.key));
            }

            generalList.forEach(el => {
                if (el.hasOwnProperty('native')) {
                    el.display = el.native + " (" + el.name + ")";
                }
                else {
                    el.display = el.name;
                }
            });

            return generalList;
        },

        updateGenders(values) {
            console.log(`updateGenders(value:${JSON.stringify(values)})`);
            this.genders_selection = values;
        },
        updateProviders(values) {
            console.log(`updateProviders(value:${JSON.stringify(values)})`);
            this.providers_selection = values;
        },
        updateTypes(values) {
            console.log(`updateTypes(value:${JSON.stringify(values)})`);
            this.types_selection = values;
        },
        updateSelected(values) {
            this.selectedvalue = values;

            console.log(`updateSelected(value:${JSON.stringify(values)})`);
        },
        async menuOpenClose(value) {
            console.log(`menuOpenClose(value:${value})`);
            this.menuState = value;

            if (value) {
                this.selectedvalue = [this.itemvalue];

                await nextTick();

                const selectedElement = this.$refs.listRef?.$el?.querySelector(
                    '.q-item--active'
                );

                if (selectedElement) {
                    // Scroll the selected item into view
                    selectedElement.scrollIntoView({
                        //behavior: 'smooth', // Optional: smooth scrolling
                        block: 'center', // Center the item in the view
                    });
                }
            }
        },
        Okay(e) {
            if (this.selectedvalue && this.selectedvalue.length)
                this.sync(this.selectedvalue[0]);

            this.menuState = false;
        },
        Cancel(e) {
            this.menuState = false;
        },

        getSimpleName(item) {
            //return item.Friendly.split(':')[1] + '; ' + (item.Name.includes(',') ? item.Name.split(',')[1].substr(7) : '');

            switch (item.Vendor) {
                case 'microsoft':
                case 'ibm':
                    return item.Friendly.split(':')[1].split(',')[0];
                case 'google':
                    return item.Name.split(',')[1].substr(7);
                default:
                    return item.Friendly.split(':')[1].split(',')[0] + "; " + item.Name;
            }
        },
        getVendorIcon(vendor) {
            switch (vendor) {
                case 'microsoft': return <QIcon size="sm" name="mdi-microsoft-windows" title="Microsoft" color="deep-purple-3"></QIcon>;
                case 'ibm': return <QIcon size="sm" name="mdi-desktop-classic" title="IBM" color="indigo-9"></QIcon>;
                case 'google': return <QIcon size="sm" name="mdi-google" title="Google" color="blue"></QIcon>;
                default: return <QIcon size="sm" name="mdi-help-circle" title={vendor}></QIcon>;
            }
        },
        getGenderIcon(name) {
            if (name.includes(`(Male)`))
                return <QIcon size="sm" name="mdi-human-male" color="indigo" title="Male"></QIcon>;
            else if (name.includes('(Female)'))
                return <QIcon size="sm" name="mdi-human-female" color="pink-10" title="Female"></QIcon>;
            else
                return <QIcon size="sm" name="mdi-human-male-female" title="Neutral"></QIcon>;
        },
        getTypeIcon(name) {
            if (name.includes(`Neural`))
                return <QIcon size="sm" name="mdi-brain" color="indigo" title="Neural"></QIcon>;
            else if (name.includes('Standard'))
                return <QIcon size="sm" name="mdi-disc-player" color="pink-10" title="Standard"></QIcon>;
            else if (name.includes('Wavenet'))
                return <QIcon size="sm" name="mdi-sine-wave" color="pink-10" title="Wavenet"></QIcon>;
            else if (name.includes('Studio'))
                return <QIcon size="sm" name="mdi-speaker" color="pink-10" title="Studio"></QIcon>;
            else if (name.includes('News'))
                return <QIcon size="sm" name="mdi-broadcast" color="pink-10" title="News"></QIcon>;
            else
                return <QIcon size="sm" name="mdi-human-male-female" title={name}></QIcon>;
        },
        getSampleButton(item) {
            if (item.Name && item.Name == this.nameplaying) // This element is currently playing
                switch (this.soundPlayer?.State) {
                    case 'Stopped':
                        return <QBtn flat size="sm" dense icon="mdi-loading" disable loading>
                        </QBtn>;

                    case 'Playing':
                        return <QBtn flat size="sm" dense icon="mdi-stop" title="Stop"
                            onClick={(e) => this.stopSample(e, item)}
                            onMousedown={(e) => e.stopPropagation()}
                        >
                        </QBtn>;

                    default:
                        console.log(`getSampleButton item:${item.Name}; soundPlayerState:${this.soundPlayer?.State}`);
                        return <QBtn flat size="sm" dense icon="mdi-loading" disable loading></QBtn>;
                }
            else
                switch (this.soundPlayer?.State) {
                    case 'Stopped':
                        return <QBtn flat size="sm" dense icon="mdi-play-circle" title="Play Sample"
                            onClick={(e) => this.playSample(e, item)}
                            onMousedown={(e) => e.stopPropagation()}
                        >
                        </QBtn>;

                    default:
                        return <QBtn flat size="sm" dense icon="mdi-play-circle" title="Play Sample" disable></QBtn>;
                }

        },
        getPlayButton(item) {
            // Unused
            if (!item)
                item = {
                    Name: this.itemvalue,
                    Locale: this.locale,
                };
            const isdisabled = !item.Name || !item.Locale;
            if (item.Name && item.Name == this.nameplaying) // This element is currently playing
                switch (this.soundPlayer?.State) {
                    case 'Stopped':
                        return <QBtn flat size="sm" dense icon="mdi-play-circle" title="Play Sample"
                            onMousedown={(e) => e.stopPropagation()}
                            disable={isdisabled}>
                        </QBtn>;

                    case 'Playing':
                        return <QBtn flat size="sm" dense icon="mdi-stop" title="Stop"
                            onClick={(e) => this.stopSample(e, item)}
                            onMousedown={(e) => e.stopPropagation()}
                        >
                        </QBtn>;

                    default:
                        return <QBtn flat size="sm" dense icon="mdi-loading" disable loading></QBtn>;
                }
            else
                switch (this.soundPlayer?.State) {
                    case 'Stopped':
                        return <QBtn flat size="sm" dense icon="mdi-play-circle" title="Play Sample"
                            onClick={(e) => this.playSample(e, item)}
                            onMousedown={(e) => e.stopPropagation()}
                        >
                        </QBtn>;

                    default:
                        return <QBtn flat size="sm" dense icon="mdi-play-circle" title="Play Sample" disable></QBtn>;
                }
        },
        playSample(e, item) {
            e.preventDefault();
            e.stopPropagation();

            // Example:
            // soundPlayer.PlaySound('Apps/Files/GenerateTTS?text='+util.urlEncode(ParentByType('FormField').FieldValue)+'&options={ "locale":"'+ParamByName('Locale', false, true)+'", "voice":"'+ParamByName('Voice', false, true)+'"}')
            const text = encodeURIComponent(this.sampleText);
            const options = {
                locale: item.Locale,
                voice: item.Name,
            };
            const url = `Apps/Files/GenerateTTS?text=${text}&options=${JSON.stringify(options)}`;
            this.nameplaying = item.Name;
            this.soundPlayer.PlaySound(url);
        },
        stopSample(e, item) {
            e.preventDefault();
            e.stopPropagation();

            this.soundPlayer.Stop();
            this.nameplaying = null;
        },
        updateSampleText(text) {
            this.sampleText = text;
            if (this.locale && this.locale.includes('-')) {
                const key = `TTSVoicePicker-SampleVoice-${this.locale.split('-')[0]}`;
                this.System.LocalStorage(key, text);
                console.log(`Saving TTS sample text to key:${key} as ${text}`);
            }
        },

        sortBy(item1, item2, mode) {
            switch (mode) {
                case 'na': return this.getSimpleName(item1).localeCompare(this.getSimpleName(item2));
                case 'nd': return this.getSimpleName(item2).localeCompare(this.getSimpleName(item1));
                case 'pa': return item1.Name.localeCompare(item2.Name);
                case 'pd': return item2.Name.localeCompare(item1.Name);
                default:
                    return 0;
            }
        },
    },
    render() {
        let slots = {
            message: ({ message }) => {
                return <TranslationContainer context={this} value={message}></TranslationContainer>
            },
            ['prepend']: () => this.getSampleButton({ Name: this.itemvalue,Locale: this.locale }),
            ['append']: () => {
                const genderOptions = this.genders.map(g => ({ label: g.title, value: g.title }));
                const providerOptions = this.providers.map(p => ({ label: p, value: p }));
                const typeOptions = this.types.map(t => ({ label: t.title, value: t.title }));
                const menuContent = (
                    <QCard style="width: 660px;">
                        <QBar >
                            <QToolbarTitle>TTS Voice Selection</QToolbarTitle>
                            <QSpace />
                            <QBtn flat round dense icon="mdi-cog" size="sm" title="Change sample text"
                                onClick={() => this.sampleTextVisible = !this.sampleTextVisible}
                            ></QBtn>
                        </QBar>
                        <QCardSection>
                            {this.sampleTextVisible ?
                                <QInput class="q-mt-sm sform-input-white" outlined dense hide-bottom-space type="textarea" label="Sample text" rows={2}
                                    modelValue={this.sampleText}
                                    onUpdate:modelValue={this.updateSampleText}
                                ></QInput>
                                : null}
                            <div class="row q-col-gutter-sm q-mt-sm">
                                <div class="col-12 col-sm-4">
                                    <QSelect outlined dense hide-bottom-space label="Gender" multiple class="q-mt-sm"
                                        popup-content-class="q-select-max-popup-height"
                                        options={genderOptions} option-label="label" option-value="value" map-options emit-value use-chips
                                        modelValue={this.genders_selection}
                                        onUpdate:modelValue={this.updateGenders}
                                    />
                                </div>
                                <div class="col-12 col-sm-4">
                                    <QSelect outlined dense hide-bottom-space label="Provider" multiple class="q-mt-sm"
                                        popup-content-class="q-select-max-popup-height"
                                        options={providerOptions} option-label="label" option-value="value" map-options emit-value use-chips
                                        modelValue={this.providers_selection}
                                        onUpdate:modelValue={this.updateProviders}
                                    />
                                </div>
                                <div class="col-12 col-sm-4">
                                    <QSelect outlined dense hide-bottom-space label="Type" multiple class="q-mt-sm"
                                        popup-content-class="q-select-max-popup-height"
                                        options={typeOptions} option-label="label" option-value="value" map-options emit-value use-chips
                                        modelValue={this.types_selection}
                                        onUpdate:modelValue={this.updateTypes}
                                    />
                                </div>
                            </div>
                            <div class="q-mt-sm" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <QInput outlined dense hide-bottom-space placeholder="Search" clearable class="q-mt-sm sform-input-white" style={{ flex: 1 }}
                                    modelValue={this.search_text}
                                    onUpdate:modelValue={(v) => this.search_text = v}
                                />
                                <QBtn flat round dense icon="mdi-sort" size="md"
                                    xonClick={(e) => { e.stopPropagation(); this.sortMenuState = !this.sortMenuState; }}
                                >
                                    <QTooltip>Sort options</QTooltip>
                                    <QMenu xmodelValue={this.sortMenuState} xonUpdate:modelValue={(v) => this.sortMenuState = v}>
                                        <QList dense>
                                            {this.sortoptions.map(opt => (
                                                <QItem key={opt.value} clickable onClick={() => { this.sortselection = [opt.value]; this.sortMenuState = false; }}
                                                    active={this.sortselection && this.sortselection[0] === opt.value} active-class="text-primary">
                                                    <QItemSection no-wrap>
                                                        <QItemLabel>{opt.title}</QItemLabel>
                                                    </QItemSection>
                                                </QItem>
                                            ))}
                                        </QList>
                                    </QMenu>
                                </QBtn>
                            </div>
                            <QList ref="listRef" style={{ height: '240px', overflow: 'auto' }} dense class="q-mt-sm">
                                {this.filteredlist.map(voice => (
                                    <QItem key={voice.Name} clickable
                                        active={this.selectedvalue && this.selectedvalue[0] === voice.Name}
                                        active-class="bg-primary text-white"
                                        onClick={() => this.updateSelected([voice.Name])}
                                    >
                                        <QItemSection style="max-width: 30px;">
                                            <QAvatar >{this.getVendorIcon(voice.Vendor)}</QAvatar>
                                        </QItemSection>
                                        <QItemSection style="max-width: 30px;">
                                            <QAvatar>{this.getGenderIcon(voice.Friendly)}</QAvatar>
                                        </QItemSection>
                                        <QItemSection style="max-width: 30px;">
                                            <QAvatar>{this.getTypeIcon(voice.Friendly)}</QAvatar>
                                        </QItemSection>
                                        <QItemSection>
                                            <QItemLabel>{this.getSimpleName(voice)}</QItemLabel>
                                            <QItemLabel caption>{voice.Region.split('-')[1]}</QItemLabel>
                                        </QItemSection>
                                        <QItemSection side>{this.getSampleButton(voice)}</QItemSection>
                                    </QItem>
                                ))}
                            </QList>
                        </QCardSection>
                        <QCardActions align="right">
                            <QSpace />
                            <QBtn flat color="primary" onClick={this.Okay}>OK</QBtn>
                            <QBtn flat color="primary" onClick={this.Cancel}>Cancel</QBtn>
                        </QCardActions>
                    </QCard>
                );
                return (
                    <QBtn
                        icon="mdi-microsoft-xbox-controller-menu"
                        flat dense color="primary"
                        onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.menuState = !this.menuState; }}
                        xonMousedown={(e) => e.stopPropagation()}
                    >
                        <QMenu xmodelValue={this.menuState} xonUpdate:modelValue={this.menuOpenClose} anchor="bottom start" self="top end"
                            target={true}
                        >
                            {menuContent}
                        </QMenu>
                    </QBtn>
                );
            },
        };

        if (this.hasInputLabel)
            slots.label = () => <TranslationContainer slot="label" context={this} value={this.labelText}></TranslationContainer>;

        const selectOptions = (this.listitems || []).map(v => ({ label: v.Friendly, value: v.Name }));
        let input = (
            <QSelect
                class="c-formSelect caption q-ma-none"
                style={{ width: "100%", paddingTop: "5px" }}
                popup-content-class="q-select-max-popup-height"
                outlined dense
                labelSlot={this.hasInputLabel}
                use-input fill-input hide-selected
                modelValue={this.itemvalue}
                rules={this.rules} {...this.compilerErrorFieldProps}
                options={selectOptions}
                option-label="label"
                option-value="value"
                map-options emit-value
                onUpdate:modelValue={(value) => this.sync(value)}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                hint={this.inputHint}
                hide-hint
                bottom-slots={this.showFieldBottomSlots}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
            >{slots}</QSelect>
        );

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);

        // if (this.directives && this.directives.some(a => a.name == 'on-enter-default'))
        //    input.props.autofocus = true;

        if (this.directives) {
            var applyDirectives = this.directives.map(d => {
                const dirDef = d.directive || resolveDirective(d.name);

                return [dirDef, d.value, d.arg, d.modifiers];
            });
            input = withDirectives(input, applyDirectives);
        }

        return input;
    }
});